import { memo } from 'react';
import styles from './styles.module.scss';

export const Icon = memo(function Icon({
  iconId,
  large,
  xl,
  hasBackground = true,
  type = 'icons',
  fileFormat = 'png',
  noPadding = false,
  children,
}: {
  iconId: string;
  large?: boolean;
  xl?: boolean;
  hasBackground?: boolean;
  type?: 'icons' | 'buttons' | 'upgrades';
  fileFormat?: 'png' | 'jpg' | 'gif';
  noPadding?: boolean;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={`${styles.icon} ${large ? styles.large : ''} ${xl ? styles.xl : ''
        } ${hasBackground ? styles.hasBackground : ''} ${noPadding ? styles.noPadding : ''}`}
    >
      <img src={`ui/${type}/${iconId}.${fileFormat}`} alt={iconId} />
      {children}
    </div>
  );
});
